import React, { ReactElement, FunctionComponent, useEffect } from 'react'
import Grid from '@sport1/react-elements/Grid'
import CardHeadlineFont from '../../Theme/Fonts/CardHeadline'
import { TestID } from '../../utils/PropTypesDefinitions'
import { logComponentDeprecation } from '../../utils/Deprecation'

export type NextCardHeadlineProps = {
    text: string
} & TestID

const NextCardHeadline: FunctionComponent<NextCardHeadlineProps> = ({
    text,
    testID,
}): ReactElement => {
    /* istanbul ignore next */
    useEffect((): void => {
        logComponentDeprecation('NextCardHeadline')
    }, [])
    return (
        <Grid noExpand backgroundColor="pearl" testID={testID} minWidth={0}>
            <CardHeadlineFont numberOfLines={1}>{text}</CardHeadlineFont>
        </Grid>
    )
}

export default NextCardHeadline
